/**
 * Shared depot-time helpers for docket screens.
 *
 * - hasDepotTimes(item)   → true when a line has any depot time recorded
 * - deriveDepotTravel(item) → { travel_out_minutes, travel_return_minutes, travel_minutes } or null
 */

export const hasDepotTimes = (item) =>
  !!(item?.depart_depot_time || item?.arrive_depot_time);

/**
 * Client-side derivation of travel legs from four HH:MM times.
 * Mirrors backend logic in backend/services/depot_travel.py.
 */
export const deriveDepotTravel = (item) => {
  const { depart_depot_time, arrive_depot_time, start_time, finish_time } = item || {};
  if (!depart_depot_time || !arrive_depot_time || !start_time || !finish_time) return null;
  try {
    const toMins = (hhmm) => {
      const [h, m] = hhmm.split(':').map(Number);
      if (isNaN(h) || isNaN(m) || h < 0 || h > 23 || m < 0 || m > 59) return null;
      return h * 60 + m;
    };
    const dep = toMins(depart_depot_time);
    const arr = toMins(arrive_depot_time);
    const st  = toMins(start_time);
    const fi  = toMins(finish_time);
    if (dep === null || arr === null || st === null || fi === null) return null;
    let out = st - dep;
    if (out < 0) out += 1440;
    let ret = arr - fi;
    if (ret < 0) ret += 1440;
    return { travel_out_minutes: out, travel_return_minutes: ret, travel_minutes: out + ret };
  } catch {
    return null;
  }
};
